/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseConnectionViewData } from './genericApiResponseConnectionViewData';
import type { GenericApiResponseConnectionViewMessage } from './genericApiResponseConnectionViewMessage';
import type { GenericApiResponseConnectionViewPagination } from './genericApiResponseConnectionViewPagination';
import type { GenericApiResponseConnectionViewError } from './genericApiResponseConnectionViewError';

export interface GenericApiResponseConnectionView {
  data?: GenericApiResponseConnectionViewData;
  message?: GenericApiResponseConnectionViewMessage;
  pagination?: GenericApiResponseConnectionViewPagination;
  error?: GenericApiResponseConnectionViewError;
  statusCode?: number;
}
